import React from 'react';
import { Typography, Avatar, Divider } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Edit as EditIcon, Info as InfoIcon, Warning as WarningIcon } from '@mui/icons-material';
import ChipCompletedStep from '../ChipCompletedStep';
import LightTooltip from '../LightTooltip';
import './SummarySection.scss';

/**
 * @typedef {{step: number; isStepValid: boolean;}} EditStep
 * @param {{
 *  index?: any;
 *  title?: any;
 *  editStep?: EditStep;
 *  onEditClick: *;
 *  displayInfoIconOnly?: boolean;
 *  warningMessage?: string;
 *  children?: React.ReactNode;
 * }} param0
 */
const SummarySection = ({
    index,
    title,
    editStep,
    onEditClick,
    displayInfoIconOnly = false,
    warningMessage = '',
    children,
}) => {
    const { isStepValid } = editStep || {};

    return (
        <div className="core--summary-section-container">
            <div className="core--summary-section">
                <div className="header-container">
                    <div className="header-container-left">
                        <Avatar>{index}</Avatar>
                        <Typography variant="h6">{title}</Typography>
                        {warningMessage && (
                            <LightTooltip
                                title={warningMessage}
                                arrow
                                placement="top"
                            >
                                <div className="summary-section--warning-icon">
                                    <WarningIcon />
                                </div>
                            </LightTooltip>
                        )}
                    </div>
                    {editStep && (
                        <div className="header-container-right">
                            {isStepValid && <ChipCompletedStep />}
                            <IconButton
                                className="edit-icon"
                                onClick={onEditClick}
                            >
                                {
                                    displayInfoIconOnly
                                        ? <InfoIcon className="info-icon" />
                                        : <EditIcon fontSize="inherit" />
                                }
                            </IconButton>
                        </div>
                    )}
                </div>
                <div className="summary-content-container">
                    {children}
                </div>
            </div>
            <Divider />
        </div>
    );
};

export default SummarySection;
